
export class THQDeptModel {
    
    Id: any;
    DepartmentName: any;
    TypeCode: any;
    IsActive:any;
    
}